/**
 * Checkbox constants
 */

export const CHECKBOX_TRUE_VALUES     = [ 'TRUE', 'YES', '1' ]
export const CHECKBOX_FALSE_VALUES    = [ 'FALSE', 'NO', '0', '-1' ]
